import { getCookie } from 'cookies-next/client'

import { COOKIE_ECONDA_SESSION_ID_NAME } from '../../cookies/cookieNames'
import { cookiesGetEcondaVisitorId } from '../../cookies/cookiesGetEcondaVisitorId'
import { PUBLIC_API_PREFIX } from '../../url-handling/PUBLIC_API_PREFIX'

/**
 * Track optimizely event with event key and event tags
 * Uses sendBeacon to cover edge cases
 */
export const experimentsTrackEvent = (
  eventKey: string,
  eventTags: object = {},
): void => {
  // eslint-disable-next-line unicorn/try-complexity -- don't reference, refactor if touched
  try {
    const econdaIds = {
      econdaSessionId: getCookie(COOKIE_ECONDA_SESSION_ID_NAME)?.split(
        ':',
        1,
      )[0],
      econdaVisitorId: cookiesGetEcondaVisitorId(),
    }

    const eventTagsWithEcondaIds = Object.assign(econdaIds, eventTags)

    const blob = new Blob(
      [JSON.stringify({ eventKey, eventTags: eventTagsWithEcondaIds })],
      {
        type: 'application/json;charset=UTF-8',
      },
    )

    navigator.sendBeacon(`${PUBLIC_API_PREFIX}/api/experiments/track`, blob)
  } catch {
    // void
  }
}
